import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { site } from '@panel/commons/helpers';
import IconCheck from '../../assets/icons/circleCheck.svg';
import IconCheckUB from '../../assets/icons/circleCheck_UB.svg';

const siteId = site.id;

const Container = styled.div`
  width: ${({ device }) => (device === 'mobile' ? '100%' : '370px')};
  height: ${({ device }) => (device === 'mobile' ? 'fit-content' : '416px')};
  background-color: ${select('white')};
  margin: ${({ device }) => {
    if (device === 'mobile') return '24px 0px 40px 0px';
    if (device === 'tablet') return '38px auto';
    return '56px auto';
  }};
  padding: ${({ device }) => (device === 'mobile' ? '0px 18.5px' : '40px 0px')};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-family: 'Hind';
  font-style: normal;
  @media (min-width: 768px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        width: 375px;
        height: fit-content;
        margin: 56px auto;
        padding: 0px;
      `}
  }
  .info-cta {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`;

const Title = styled.div`
  width: 100%;
  font-weight: 600;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
  white-space: break-spaces;
  padding: 0 32px;
  margin-bottom: 24px;
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        display: none;
      `}
  }
  @media (min-width: 1024px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        display: none;
      `}
  }
  @media (min-width: 1366px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        display: flex;
      `}
  }
`;

const ListContainer = styled.div`
  width: ${({ device }) => (device === 'mobile' ? '100%' : '310px')};
  height: ${({ device }) => (device === 'desktop' ? '205px' : 'auto')};
  overflow-y: ${({ device }) => (device === 'mobile' ? 'visible' : 'auto')};
  ::-webkit-scrollbar {
    -webkit-appearance: none;
  }
  ::-webkit-scrollbar:vertical {
    background-color: transparent;
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 32px;
    border: 9px solid ${select('grayMediumLight2')};
    z-index: 2;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 32px;
  }
  @media (max-width: 820px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        width: 100%;
        overflow-y: visible;
      `}
  }
  @media (max-width: 1024px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        width: 100%;
      `}
  }
`;

const RowZone = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: ${({ device }) => (device === 'desktop' ? 'space-between' : 'flex-start')};
  gap: 16px;
  margin-bottom: 16px;
  .column-zone {
    width: ${({ device }) => (device === 'mobile' ? '280px' : '273px')};
    position: relative;
    @media (max-width: 820px) {
      ${({ device }) =>
        device === 'tablet' &&
        css`
          width: 100%;
        `}
    }
  }
  .title-zone {
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    white-space: break-spaces;
  }
`;

const SubZoneContainer = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  white-space: break-spaces;
  display: ${({ active }) => (active ? 'none' : 'block')};
`;

const HiddenSubZoneContainer = styled.div`
  max-height: ${({ active }) => (active ? '600px' : '0px')};
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  white-space: break-spaces;
  cursor: pointer;
  opacity: ${({ active }) => (active ? '1' : '0')};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  overflow: hidden;
`;

const CTAMoreZones = styled.div`
  display: ${({ active }) => (active ? 'none' : 'block')};
  font-weight: 500;
  font-size: 12px;
  line-height: 19px;
  text-decoration: underline;
  cursor: pointer;
  position: absolute;
  top: ${({ device, topM, topD, topTH }) => {
    if (device === 'mobile') return `${topM}px`;
    if (device === 'tablet') return `${topTH}px`;
    return `${topD}px`;
  }};

  left: ${({ device, leftM, leftD, leftTH }) => {
    if (device === 'mobile') return `${leftM}px`;
    if (device === 'tablet') return `${leftTH}px`;
    return `${leftD}px`;
  }};
  @media (max-width: 820px) {
    ${({ device, topTV, leftTV }) =>
      device === 'tablet' &&
      css`
        top: ${topTV}px;
        left: ${leftTV}px;
      `}
  }
`;

const Icon = styled.div`
  width: 22px;
  height: 21px;
  background-image: url(${siteId === 'UBPE' ? IconCheckUB : IconCheck});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;

const TextInfo = styled.div`
  width: ${({ device }) => (device === 'desktop' ? '279px' : '100%')};
  height: ${({ device }) => (device === 'tablet' ? '22px' : '44px')};
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  white-space: break-spaces;
  margin-top: 24px;
  @media (min-width: 1024px) {
    ${({ device }) =>
      device === 'tablet' &&
      css`
        width: 279px;
        height: 44px;
      `}
  }
`;

const CTA = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ device }) => {
    if (device === 'mobile') return '100%';
    if (device === 'tablet') return '375px';
    return '290px';
  }};
  height: 48px;
  color: ${select('white')};
  background: ${getColor('primary')};
  border-radius: 8px;
  font-weight: 600;
  font-size: 18px;
  line-height: 130%;
  cursor: pointer;
  :hover {
    background-color: ${getColor('primaryHover')};
  }
`;

export {
  Container,
  Title,
  ListContainer,
  RowZone,
  Icon,
  SubZoneContainer,
  HiddenSubZoneContainer,
  CTAMoreZones,
  TextInfo,
  CTA
};
